module.exports = __webpack_public_path__ + "static/madame-figaro-couverture-2-6d8a7b912584d49f571af8c487504ed2.jpg";